export * from './affiliation-code/affiliation-code.component';
export * from './affiliation-code-utf/affiliation-code-utf.component';
export * from './customer-eligibility/customer-eligibility.component';
export * from './customer-information/customer-information.component';
export * from './customer-information-utf/customer-information-utf.component';
export * from './customer-profile/customer-profile.component';
export * from './customer-profile-utf/customer-profile-utf.component';
export * from './complete-profile/complete-profile.component';
export * from './complete-profile-utf/complete-profile-utf.component';
export * from './session-time-out/session-time-out.component';
export * from './session-time-out-utf/session-time-out-utf.component';
export * from './error-page/error-page.component';
export * from './error-page-utf/error-page-utf.component';
export * from './utf-registration-verify/utf-registration-verify/utf-registration-verify.component';
export * from './utf-auth-page/utf-auth-page.component';
export * from './customer-eligibility-utf/customer-eligibility-utf.component';
export * from './utf-auth-single-id/utf-auth-single-id.component';
export * from './utf-unauth-page/utf-unauth-page.component';
export * from './utf-sync-info/utf-sync-info.component';
export * from './utf-syncing-information/utf-syncing-information.component';
